import React, { useCallback, useEffect, useState } from 'react'
import { getAllStudent, userEditData } from '../../redux/services/studentSlice';
import { useDispatch, useSelector } from 'react-redux';
import Table from '../../common/Table';
import { MdBlock } from 'react-icons/md';
import { convertUtcToIstDateOnly } from '../../common/TimeUtils';
import { toast } from 'react-toastify';
import fallbackCopyText from '../../common/copyToText';

const UserReport = () => {
    const [userPage, setUserPage] = useState(0);
    const dispatch = useDispatch();
    const limitOptions = [
      { value: 10, label: 10 },
      { value: 30, label: 30 },
      { value: 50, label: 50},
      { value: 100, label: 100 },
    ];
    const [pageLimit, setPageLimit] = useState(limitOptions[0]?.value);
    const getStudentData = useSelector((state) => state.student.studentData);
    const getAllStudentApi = useCallback(async () => {
        try {
          await dispatch(
            getAllStudent({ page: userPage + 1, limit:pageLimit, blockFilter: true })
          );
        } catch (error) {}
      }, [dispatch, userPage, pageLimit]);
    
      useEffect(() => {
        getAllStudentApi();
      }, [getAllStudentApi]);
      const editUser = async (userId) => {
        let payload = {
          userId: userId,
          isBlocked: false,
        };
        try {
          const response = await dispatch(userEditData(payload));
          if (response) {
            getAllStudentApi();
          }
        } catch (error) {}
      };
        const userColumns = [
    {
      header: "S/N",
      key: "index",
      render: (_, __, index) => userPage * pageLimit + index + 1,
    },
    {
      header: "Copy ID",
      key: "copy",
      render: (_, row) => (
        <button
          className="py-1 px-3 rounded-xl text-white bg-accent font-semibold"
          onClick={() => {
            if (navigator.clipboard && navigator.clipboard.writeText) {
              navigator.clipboard
                .writeText(row?._id)
                .then(() => {
                  toast.success("ID copied to clipboard!", {
                    autoClose: 2000,
                    pauseOnHover: false,
                  });
                })
                .catch((err) => {
                  fallbackCopyText(row?._id);
                });
            } else {
              fallbackCopyText(row?._id);
            }
          }}
        >
          Copy
        </button>
      ),
    },
    {
      header: "Name",
      key: "name",
      render: (_, row) => {
        if (!row) {
          return "-";
        }
        return `${row?.firstName + " " + row?.lastName}`;
      },
    },
    {
      header: "Referral Code",
      key: "refferral-code",
      render: (_, row) => row?.referralCode || "-",
    },
    {
      header: "Contact",
      key: "contact",
      render: (_, row) =>
        row?.contact?.mobile
          ? `${row?.contact?.countryCode} ${row?.contact?.mobile}`
          : "-",
    },
    {
      header: "Email",
      key: "email",
      render: (_, row) => row?.email || "-",
    },
    {
      header: "DOB",
      key: "dob",
      render: (_, row) => (row?.dob ? convertUtcToIstDateOnly(row.dob) : "-"),
    },
    {
      header: "Balance",
      key: "balance",
      render: (_, row) => row?.walletBalance.toFixed(2) || "-",
    },
    {
      header: "Unlock",
      key: "unlock",
      render: (_, row) => (
        <div className="flex justify-center">
          <MdBlock
            className={` ${
              row.isBlocked ? "text-green-600" : "text-red-600 "
            } w-6 h-6 text-foreground `}
            onClick={() => editUser(row._id)}
          />
        </div>
      ),
    },
  ];
  return (
    <div>
        <Table
          title="User Report"
          columns={userColumns}
          data={getStudentData?.subject_data || []}
          onPageChange={(selectedItem) => setUserPage(selectedItem.selected)}
          pageCount={getStudentData?.state?.page_limit}
          pageLimitOptions={limitOptions}
          selectedPageLimit={pageLimit}
          onPageLimitChange={setPageLimit}
        />
    </div>
  )
}

export default UserReport
